module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img7-026c77a438618d18095765e6f6734c54.svg";